<template>
  <el-dialog title="编辑路由" :visible.sync="dialogShow">
    <el-form :model="form" :rules="rules" ref="formRules">
      <el-form-item
        label="父路由名称"
        :label-width="formLabelWidth"
        prop="parentId"
      >
        <el-col :span="12">
          <el-select
            v-model="form.parentId"
            placeholder="--请选择--"
            :disabled="isSuccess"
          >
            <el-option
              v-for="router in routerList"
              :label="router.name"
              :key="router.value"
              :value="router.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-form-item>

      <el-form-item
        label="路由名称"
        :label-width="formLabelWidth"
        prop="routeName"
      >
        <el-col :span="10">
          <el-input v-model="form.routeName" auto-complete="off"></el-input>
        </el-col>
      </el-form-item>

      <el-form-item label="路由地址" :label-width="formLabelWidth" prop="url">
        <el-col :span="10">
          <el-input v-model="form.url" auto-complete="off"></el-input>
        </el-col>
      </el-form-item>

      <el-form-item
        label="是否锁定"
        :label-width="formLabelWidth"
        prop="isLocked"
      >
        <el-col :span="12">
          <el-select v-model="form.isLocked" placeholder="--请选择--">
            <el-option label="否" value="0"></el-option>
            <el-option label="是" value="1"></el-option>
          </el-select>
        </el-col>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="submitFrom">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "SystemRoleEdit",
  props: {
    show: Boolean,
    isShow: Boolean,
    value: Object,
    formRules: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dialogShow: this.show,
      routerList: [],
      systemList: [],
      isSuccess: this.isShow,
      form: {
        parentId: "",
        routeName: "",
        isLocked: "",
        level: "",
        url: "",
        sysId: "",
      },
      formLabelWidth: "120px",
      rules: {
        isLocked: [{ required: true, message: "是否锁定", trigger: "change" }],
        parentName: [
          { required: true, message: "请选择所属平台", trigger: "change" },
        ],
      },
      routerId: "",
    };
  },
  methods: {
    systemNameChange() {
      console.log("form.sysId:" + this.form.sysId);
      this.$axios
        .get("/sysRouterInfo/selectOption", {
          params: { systemId: this.form.sysId },
        })
        .then((res) => {
          this.routerList = res.data;
        });
    },
    submitFrom() {
      this.$refs.formRules.validate((valid) => {
        if (valid) {
          let param = {};
          param.parentId = this.form.parentId;
          param.name = this.form.routeName;
          param.isLocked = this.form.isLocked;
          param.url = this.form.url;
          param.id = this.routerId;
          param.systemId = this.form.sysId;
          console.log("param:" + JSON.stringify(param));
          this.$axios.post("/sysRouterInfo/saveRouter", param).then((res) => {
            if (res.code === 200) {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "success",
              });
              this.dialogShow = false;
              this.$emit("update:show", false);
              this.$bus.$emit("refresh"); //通知刷新
            } else {
              this.$notify.error({
                title: "提示",
                message: res.msg,
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeDialog() {
      this.dialogShow = false;
      this.$emit("update:show", false);
    },
  },
  watch: {
    show(newVal) {
      this.dialogShow = newVal;
    },
    isShow(newVal) {
      this.isSuccess = newVal;
    },
    value(newVal) {
      //                console.log("newVal:"+JSON.stringify(newVal))
      this.routerId = newVal.id;
      this.form.parentId = newVal.parentId;
      this.form.routeName = newVal.routerName;
      this.form.isLocked = newVal.isLocked;
      this.form.url = newVal.url;
      this.form.sysId = newVal.sysId;
      this.systemNameChange();
      this.dialogShow = true;
      this.$emit("update:show", true);
      if (this.$refs.formRules !== undefined) {
        this.$refs.formRules.clearValidate();
      }
    },
  },
  created() {},
};
</script>

<style scoped>
</style>